import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon, XIcon, SparklesIcon, StarIcon, CrownIcon } from 'lucide-react';
import type { Page } from '../App';
export function BottleServicePage({
  onBack,
  onReserve
}: {
  onBack: () => void;
  onReserve: () => void;
}) {
  const [selectedPackage, setSelectedPackage] = useState<string | null>(null);
  const [inquiryOpen, setInquiryOpen] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [date, setDate] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = () => {
    if (!name || !email || !date) return;
    setSubmitted(true);
  };
  return <div className="min-h-screen w-full bg-[#050505] pt-24 pb-20 px-4 sm:px-6" data-id="element-485">
      <div className="max-w-7xl mx-auto" data-id="element-486">
        {/* Back */}
        <motion.button initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.4
      }} onClick={onBack} className="flex items-center gap-2 font-montserrat text-[12px] tracking-widest text-white/40 hover:text-[#C9A84C] transition-colors duration-300 mb-10" data-id="element-487">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" data-id="element-488">
            <path d="M10 3L5 8l5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-489" />
          </svg>
          BACK TO HOME
        </motion.button>

        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-490">
          <span className="font-inter text-[13px] tracking-[0.4em] text-[#C9A84C]/60 uppercase" data-id="element-491">
            Premium Experience
          </span>
          <h1 className="font-montserrat font-black text-4xl sm:text-5xl tracking-widest text-white mt-2" data-id="element-492">
            BOTTLE SERVICE
          </h1>
          <div className="w-14 h-px bg-[#C9A84C]/50 mx-auto mt-4 mb-5" data-id="element-493" />
          <p className="font-inter font-light text-[16px] text-white/55 max-w-xl mx-auto leading-relaxed" data-id="element-494">
            Elevate your night with exclusive bottle service packages. Reserve
            your VIP section and enjoy premium spirits with dedicated service.
          </p>
        </motion.div>

        {/* Packages */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-495">
          {/* Essential */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0
        }} onClick={() => setSelectedPackage(selectedPackage === 'essential' ? null : 'essential')} className="rounded-3xl p-7 cursor-pointer transition-all duration-300 group" style={{
          background: selectedPackage === 'essential' ? 'rgba(201,168,76,0.08)' : '#0d0b09',
          border: selectedPackage === 'essential' ? '1px solid rgba(201,168,76,0.5)' : '1px solid #2A2622',
          boxShadow: selectedPackage === 'essential' ? '0 0 40px rgba(201,168,76,0.1)' : '0 8px 40px rgba(0,0,0,0.6)'
        }} data-id="element-496">
            <div className="w-12 h-12 rounded-2xl flex items-center justify-center mb-5" style={{
            background: 'rgba(201,168,76,0.12)',
            border: '1px solid rgba(201,168,76,0.2)'
          }} data-id="element-497">
              <SparklesIcon size={22} className="text-[#C9A84C]" data-id="element-498" />
            </div>
            <p className="font-montserrat text-[11px] tracking-widest text-[#C9A84C]/60 mb-1" data-id="element-499">
              STARTER
            </p>
            <h3 className="font-montserrat font-black text-2xl tracking-widest text-white mb-1" data-id="element-500">
              ESSENTIAL
            </h3>
            <div className="flex items-baseline gap-1 mb-5" data-id="element-501">
              <span className="font-montserrat font-black text-4xl text-[#C9A84C]" data-id="element-502">
                $500
              </span>
              <span className="font-inter text-[14px] text-white/40" data-id="element-503">
                minimum
              </span>
            </div>
            <div className="h-px bg-[#2A2622] mb-5" data-id="element-504" />
            <ul className="space-y-3 mb-7" data-id="element-505">
              {['1 Premium bottle of your choice', 'Dedicated section for up to 6 guests', 'Mixers & garnishes included', 'Dedicated bottle service host', 'Priority entry'].map(f => <li key={f} className="flex items-start gap-3" data-id="element-506">
                  <div className="w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{
                background: 'rgba(201,168,76,0.15)'
              }} data-id="element-507">
                    <CheckIcon size={10} className="text-[#C9A84C]" data-id="element-508" />
                  </div>
                  <span className="font-inter text-[14px] text-white/65 leading-snug" data-id="element-509">
                    {f}
                  </span>
                </li>)}
            </ul>
            <button onClick={e => {
            e.stopPropagation();
            setInquiryOpen(true);
          }} className="w-full font-montserrat font-black text-[13px] tracking-widest py-3.5 rounded-xl transition-all duration-300" style={{
            background: selectedPackage === 'essential' ? '#C9A84C' : 'transparent',
            color: selectedPackage === 'essential' ? '#050505' : '#C9A84C',
            border: selectedPackage === 'essential' ? 'none' : '1px solid rgba(201,168,76,0.4)'
          }} data-id="element-510">
              BOOK ESSENTIAL
            </button>
          </motion.div>

          {/* Prestige — featured */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.1
        }} onClick={() => setSelectedPackage(selectedPackage === 'prestige' ? null : 'prestige')} className="rounded-3xl p-7 cursor-pointer transition-all duration-300 relative" style={{
          background: 'rgba(201,168,76,0.07)',
          border: '1px solid rgba(201,168,76,0.45)',
          boxShadow: '0 0 60px rgba(201,168,76,0.12), 0 8px 40px rgba(0,0,0,0.6)',
          transform: 'scale(1.03)'
        }} data-id="element-511">
            <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full font-montserrat font-black text-[10px] tracking-widest text-[#050505]" style={{
            background: '#C9A84C'
          }} data-id="element-512">
              MOST POPULAR
            </div>
            <div className="w-12 h-12 rounded-2xl flex items-center justify-center mb-5" style={{
            background: 'rgba(201,168,76,0.2)',
            border: '1px solid rgba(201,168,76,0.3)'
          }} data-id="element-513">
              <StarIcon size={22} className="text-[#C9A84C]" data-id="element-514" />
            </div>
            <p className="font-montserrat text-[11px] tracking-widest text-[#C9A84C]/60 mb-1" data-id="element-515">
              SIGNATURE
            </p>
            <h3 className="font-montserrat font-black text-2xl tracking-widest text-white mb-1" data-id="element-516">
              PRESTIGE
            </h3>
            <div className="flex items-baseline gap-1 mb-5" data-id="element-517">
              <span className="font-montserrat font-black text-4xl text-[#C9A84C]" data-id="element-518">
                $1,200
              </span>
              <span className="font-inter text-[14px] text-white/40" data-id="element-519">
                minimum
              </span>
            </div>
            <div className="h-px bg-[#2A2622] mb-5" data-id="element-520" />
            <ul className="space-y-3 mb-7" data-id="element-521">
              {['3 Premium bottles of your choice', 'VIP section for up to 12 guests', 'Mixers, garnishes & fruit trays', 'Personal bottle service host', 'Priority entry + red carpet', 'Complimentary birthday setup', 'Champagne toast'].map(f => <li key={f} className="flex items-start gap-3" data-id="element-522">
                  <div className="w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{
                background: 'rgba(201,168,76,0.2)'
              }} data-id="element-523">
                    <CheckIcon size={10} className="text-[#C9A84C]" data-id="element-524" />
                  </div>
                  <span className="font-inter text-[14px] text-white/70 leading-snug" data-id="element-525">
                    {f}
                  </span>
                </li>)}
            </ul>
            <button onClick={e => {
            e.stopPropagation();
            setInquiryOpen(true);
          }} className="w-full font-montserrat font-black text-[13px] tracking-widest py-3.5 rounded-xl transition-all duration-300" style={{
            background: '#C9A84C',
            color: '#050505'
          }} data-id="element-526">
              BOOK PRESTIGE
            </button>
          </motion.div>

          {/* Elite */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.2
        }} onClick={() => setSelectedPackage(selectedPackage === 'elite' ? null : 'elite')} className="rounded-3xl p-7 cursor-pointer transition-all duration-300 group" style={{
          background: selectedPackage === 'elite' ? 'rgba(201,168,76,0.08)' : '#0d0b09',
          border: selectedPackage === 'elite' ? '1px solid rgba(201,168,76,0.5)' : '1px solid #2A2622',
          boxShadow: selectedPackage === 'elite' ? '0 0 40px rgba(201,168,76,0.1)' : '0 8px 40px rgba(0,0,0,0.6)'
        }} data-id="element-527">
            <div className="w-12 h-12 rounded-2xl flex items-center justify-center mb-5" style={{
            background: 'rgba(201,168,76,0.12)',
            border: '1px solid rgba(201,168,76,0.2)'
          }} data-id="element-528">
              <CrownIcon size={22} className="text-[#C9A84C]" data-id="element-529" />
            </div>
            <p className="font-montserrat text-[11px] tracking-widest text-[#C9A84C]/60 mb-1" data-id="element-530">
              ULTIMATE
            </p>
            <h3 className="font-montserrat font-black text-2xl tracking-widest text-white mb-1" data-id="element-531">
              ELITE
            </h3>
            <div className="flex items-baseline gap-1 mb-5" data-id="element-532">
              <span className="font-montserrat font-black text-4xl text-[#C9A84C]" data-id="element-533">
                $3,000
              </span>
              <span className="font-inter text-[14px] text-white/40" data-id="element-534">
                minimum
              </span>
            </div>
            <div className="h-px bg-[#2A2622] mb-5" data-id="element-535" />
            <ul className="space-y-3 mb-7" data-id="element-536">
              {['Unlimited premium bottles', 'Exclusive Skybox suite (up to 25)', 'Full catering & custom menu', 'Dedicated team of 3 hosts', 'VIP arrival experience', 'Custom décor & personalization', 'DJ shoutout & spotlight', 'Complimentary photography'].map(f => <li key={f} className="flex items-start gap-3" data-id="element-537">
                  <div className="w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{
                background: 'rgba(201,168,76,0.15)'
              }} data-id="element-538">
                    <CheckIcon size={10} className="text-[#C9A84C]" data-id="element-539" />
                  </div>
                  <span className="font-inter text-[14px] text-white/65 leading-snug" data-id="element-540">
                    {f}
                  </span>
                </li>)}
            </ul>
            <button onClick={e => {
            e.stopPropagation();
            setInquiryOpen(true);
          }} className="w-full font-montserrat font-black text-[13px] tracking-widest py-3.5 rounded-xl transition-all duration-300" style={{
            background: selectedPackage === 'elite' ? '#C9A84C' : 'transparent',
            color: selectedPackage === 'elite' ? '#050505' : '#C9A84C',
            border: selectedPackage === 'elite' ? 'none' : '1px solid rgba(201,168,76,0.4)'
          }} data-id="element-541">
              BOOK ELITE
            </button>
          </motion.div>
        </div>

        {/* Custom inquiry strip */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="rounded-3xl p-8 text-center" style={{
        background: 'rgba(201,168,76,0.05)',
        border: '1px solid rgba(201,168,76,0.15)'
      }} data-id="element-542">
          <p className="font-montserrat font-black text-xl tracking-widest text-white mb-2" data-id="element-543">
            CUSTOM EXPERIENCE?
          </p>
          <p className="font-inter text-[16px] text-white/50 mb-6 max-w-lg mx-auto leading-relaxed" data-id="element-544">
            Have specific requirements? Our team will craft a bespoke package
            tailored to your vision.
          </p>
          <button onClick={() => setInquiryOpen(true)} className="font-montserrat font-black text-[13px] tracking-widest border border-[#C9A84C]/50 text-[#C9A84C] px-8 py-3.5 rounded-xl hover:bg-[#C9A84C]/10 hover:border-[#C9A84C] transition-all duration-300" data-id="element-545">
            CONTACT US
          </button>
        </motion.div>
      </div>

      {/* Inquiry Modal */}
      <AnimatePresence data-id="element-546">
        {inquiryOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[200] flex items-center justify-center p-4" style={{
        background: 'rgba(5,5,5,0.9)',
        backdropFilter: 'blur(16px)'
      }} data-id="element-547">
            <motion.div initial={{
          scale: 0.95,
          opacity: 0,
          y: 20
        }} animate={{
          scale: 1,
          opacity: 1,
          y: 0
        }} exit={{
          scale: 0.95,
          opacity: 0,
          y: 20
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 28
        }} className="w-full max-w-md rounded-3xl overflow-hidden" style={{
          background: '#0d0b09',
          border: '1px solid #2A2622',
          boxShadow: '0 24px 80px rgba(0,0,0,0.8)'
        }} data-id="element-548">
              {!submitted ? <div className="p-7" data-id="element-549">
                  <div className="flex items-center justify-between mb-6" data-id="element-550">
                    <div data-id="element-551">
                      <p className="font-montserrat text-[10px] tracking-widest text-white/30" data-id="element-552">
                        BOTTLE SERVICE
                      </p>
                      <h3 className="font-montserrat font-black text-xl tracking-widest text-white" data-id="element-553">
                        INQUIRY
                      </h3>
                    </div>
                    <button onClick={() => setInquiryOpen(false)} className="w-8 h-8 flex items-center justify-center rounded-full border border-[#2A2622] text-white/40 hover:text-[#C9A84C] transition-colors" data-id="element-554">
                      <XIcon size={14} data-id="element-555" />
                    </button>
                  </div>
                  <div className="flex flex-col gap-3" data-id="element-556">
                    {[{
                label: 'FULL NAME',
                value: name,
                setter: setName,
                placeholder: 'Your name',
                type: 'text'
              }, {
                label: 'EMAIL',
                value: email,
                setter: setEmail,
                placeholder: 'your@email.com',
                type: 'email'
              }, {
                label: 'PHONE',
                value: phone,
                setter: setPhone,
                placeholder: '+1 (555) 000-0000',
                type: 'tel'
              }, {
                label: 'EVENT DATE',
                value: date,
                setter: setDate,
                placeholder: '',
                type: 'date'
              }].map(field => <div key={field.label} data-id="element-557">
                        <label className="font-inter text-[11px] text-white/40 mb-1 block" data-id="element-558">
                          {field.label}
                        </label>
                        <input type={field.type} value={field.value} onChange={e => field.setter(e.target.value)} placeholder={field.placeholder} className="w-full bg-white/5 border border-[#2A2622] rounded-xl px-4 py-3 text-[16px] text-white/80 font-inter focus:outline-none focus:border-[#C9A84C]/50 transition-colors placeholder:text-white/20 [color-scheme:dark]" data-id="element-559" />
                      </div>)}
                  </div>
                  <button onClick={handleSubmit} disabled={!name || !email || !date} className="w-full mt-5 font-montserrat font-black text-[13px] tracking-widest py-4 rounded-xl transition-all duration-300" style={{
              background: name && email && date ? '#C9A84C' : 'rgba(201,168,76,0.2)',
              color: name && email && date ? '#050505' : 'rgba(201,168,76,0.4)'
            }} data-id="element-560">
                    SEND INQUIRY
                  </button>
                </div> : <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} className="p-10 flex flex-col items-center text-center gap-4" data-id="element-561">
                  <motion.div initial={{
              scale: 0
            }} animate={{
              scale: 1
            }} transition={{
              type: 'spring',
              stiffness: 300,
              damping: 20,
              delay: 0.1
            }} className="w-16 h-16 rounded-full flex items-center justify-center" style={{
              background: '#C9A84C',
              boxShadow: '0 0 40px rgba(201,168,76,0.4)'
            }} data-id="element-562">
                    <CheckIcon size={28} className="text-[#050505]" data-id="element-563" />
                  </motion.div>
                  <h3 className="font-montserrat font-black text-2xl tracking-widest text-white" data-id="element-564">
                    INQUIRY SENT!
                  </h3>
                  <p className="font-inter text-[16px] text-white/50 leading-relaxed" data-id="element-565">
                    Our team will reach out within 24 hours to confirm your
                    booking.
                  </p>
                  <button onClick={() => {
              setInquiryOpen(false);
              setSubmitted(false);
            }} className="mt-2 font-montserrat font-black text-[13px] tracking-widest bg-[#C9A84C] text-[#050505] px-8 py-3.5 rounded-xl hover:bg-[#E8C97A] transition-colors" data-id="element-566">
                    DONE
                  </button>
                </motion.div>}
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}